// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2D0KR","ttsLogo":"Header_ttsLogo__3Zi3c","ttsTitle":"Header_ttsTitle__3nyhp"};